import { ERROR_MESSAGE_REQUIRED } from '../../config'
import FormSlide from '../FormSlide'

export default function YourMemberStatusSlide (props) {
  return (
    <FormSlide
      title='Participating @ Aragon?'
      stageName='Finding your place at Aragon'
      description='In the AN DAO we have roles for all levels of participation from someone who just wants to talk about DAOs to our most involved contributors. You can be as involved as you want to be and progress as fast or as slow that is comfortable for you.</br></br>If you’re looking for full-time non-DAO roles with Aragon, <a class="link" href="https://aragon.org/" target="_blank">click here</a>'
      formData={[
        {
          type: 'accordian',
          label: 'memberStatus',
          errorHandling: { required: ERROR_MESSAGE_REQUIRED },
          options: [
            {
              title: 'Community Member',
              value: 'Community Member',
              body:
                "A thriving community is the core of any successful DAO! Our Community members are people who are either new to web3 and DAOs and want to learn or people who don't have time to consistently contribute but still want to be part of a growing community helping others understand web3."
            },
            {
              title: 'Ambassador',
              value: 'Ambassador',
              body:
                'Our Ambassador Program is for those who only have a few hours a week they can participate. However they want to teach others and spread the word about Web3 and DAOs. They go out and host IRL and Online Meetups and spread the word about Governance, Web3, and the Aragon Product Stack.'
            },
            {
              title: 'Contributor',
              value: 'Contributor',
              body:
                'Our Contributors are those who work part or full time within the AN DAO on initiatives that are helping our community, Ambassadors, and the people who are using Aragon thrive. This can be anything from Technical Support to creating educational content. This is a more involved role that is awarded through our bounty process.'
            }
          ]
        }
      ]}
      {...props}
    />
  )
}
